// extracted by mini-css-extract-plugin
export default {"admin_space_text":"Layout_admin_space_text__0N-Zl","dbtype_release_text":"Layout_dbtype_release_text__KAb5R"};